import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaTimes } from 'react-icons/fa';
import Select from 'react-select';

import Const from '../../util/Constants';
import Filter from './FilterPannel';
import FieldController from '../../controller/FieldController';

class FilterMultiSelect extends React.Component {

  constructor(props) {
    super(props);
    const filter = props.filter;
    this.conditions = FieldController.getConditions(props.field.field_type);
    let condition = filter ? filter.condition : FieldController.In;
    condition = this.conditions.find(item => condition === item.value);

    this.options = FieldController.getOptions(props.field);
    if(props.restrict && props.field.field_type.includes('~user')) {
      const user = reactLocalStorage.getObject(Const.LoggedInUser);
      const children = [ user.user_id, ...user.child];
      this.options = this.options.filter(opt => children.find(child => parseInt(child) === parseInt(opt.value)) !== undefined);
    }
    
    const filters = this.options.filter(option => filter?.value?.includes(`${Const.Opt}${option?.value}${Const.Opt}`));
    this.state = { condition: condition, filters: filters };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.field.field_key !== this.props.field.field_key 
        || props.filter !== this.props.filter) {
      const filter = props.filter;
      let condition = filter ? filter.condition : FieldController.In;
      condition = this.conditions.find(item => condition === item.value);

      this.options = FieldController.getOptions(props.field);
      if(props.restrict && props.field.field_type.includes('~user')) {
        const user = reactLocalStorage.getObject(Const.LoggedInUser);
        const children = [ user.user_id, ...user.child];
        this.options = this.options.filter(opt =>
          children.find(child => parseInt(child) === parseInt(opt.value)) !== undefined);
      }
      
      const filters = this.options.filter(option => filter && 
        filter.value.includes(`${Const.Opt}${option.value}${Const.Opt}`));
      this.setState({ ...this.state, condition: condition, filters: filters });
    }
  }

  onConditionChanged = select => {
    this.setState({ ...this.state, condition: select });
    if(select.value === FieldController.Empty || select.value === FieldController.NotEmpty) {
      this.props.onValueChange(this.props.field.field_key, select.value, '', this.props.field.model_key);
    } else {
      this.props.deleteFilter(this.props.field.field_key, this.props.field.model_key);
    }
  }

  onOptionChange = selected => {
    let tmp = '';
    for(let i = 0; i < selected.length; i++) { 
      tmp = `${tmp}${selected[i].value}${Const.Opt}`;
    }
    tmp = tmp !== '' ? `${Const.Opt}${tmp}` : '';
    if(tmp !== '') {
      this.props.onValueChange(this.props.field.field_key, this.state.condition.value, tmp, this.props.field.model_key);
    } else {
      this.props.deleteFilter(this.props.field.field_key, this.props.field.model_key);
    }
    this.setState({ ...this.state, filters: selected });
  }

  static getDefaultValue = value => {
    if(value === Filter.LoggedInUserTeam)  {
      const user = reactLocalStorage.getObject(Const.LoggedInUser);
      const children = [ user.user_id, ...user.child];
      return `${Const.Opt}${children.join(Const.Opt)}${Const.Opt}`;
    } else if(value === FieldController.LoggedInUser) {
      const user = reactLocalStorage.getObject(Const.LoggedInUser);
      return `${Const.Opt}${user.user_id}${Const.Opt}`
    }
    return value;
  }

  render() {
    const condition = this.state.condition ? this.state.condition.value : '';
    const isFilter = (this.state.filters && this.state.filters.length > 0)
    || !FieldController.showSelect(Const.MultiSelect, condition);
    return (
      <>
        <div className="row pt-2">
          <div className="col-md-5">
            <p className="headingp">
              {this.props.field.model_key ? <>{this.props.field.model_name}<br/></> : ''}{this.props.field.label_name}
            </p>
          </div>
          <div className={`col-md-${isFilter ? 5: 7}`}>
            <Select value={this.state.condition} onChange={this.onConditionChanged}
              options={this.conditions} isSearchable={true} />
          </div>
          { isFilter ? <div className="col-md-1"><FaTimes 
              onClick={() => this.props.resetFilter(this.props.field.field_key)}/></div> : null }
        </div>

        <div className="row pt-2">
          { FieldController.showSelect(Const.MultiSelect, condition) ?
            <div className="col-md-12">
              <Select value={this.state.filters} onChange={this.onOptionChange}
                options={this.options} isSearchable={true} isClearable={true} isMulti={true} />
            </div> : null
          }
        </div>
        <hr />
      </>
    );
  }
}


export default FilterMultiSelect;